import {
  Component,
  ComponentRef,
  HostListener,
  inject,
  viewChild,
  ViewContainerRef,
} from '@angular/core';

import { DialogService } from '../../services/dialog/dialog.service';
import { TDialogComponent } from '../../services/dialog/dialog.interfaces';
import isObject from 'lodash/isObject';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: true,
})
export class DialogComponent<T> {
  private dialogService = inject(DialogService);

  readonly dialogContent = viewChild.required('dialogContent', { read: ViewContainerRef });

  @HostListener('document:keydown.escape') keydownEsc() {
    this.close();
  }

  @HostListener('document:click', ['$event']) click(evt: any) {
    if (evt.target.classList.contains('dialog')) {
      this.close();
    }
  }

  private dialogID!: string;
  private data!: { [key: string]: any };
  private dialogComponent!: TDialogComponent<T>;

  ngAfterViewInit() {
    const dialogReference: ComponentRef<any> = this.dialogContent().createComponent(
      this.dialogComponent
    );

    if (isObject(this.data)) {
      Object.entries(this.data).forEach(([key, value]) => {
        dialogReference.setInput(key, value);
      });
    }

    dialogReference.setInput('dialogID', this.dialogID);
  }

  close(): void {
    this.dialogService.close(this.dialogID);
  }
}
